import {Component, OnInit, Renderer2, TemplateRef, ViewChild} from '@angular/core';
import {ConfigService} from '../../config.service';
import {ScriptService} from '../../script.service';
import {AppTitleService} from '../../app-title.service';
import {GeolocationService} from '../../services/geolocation.service';
import {darkStyleMap} from '../../consts/dark-style-map.const';
import {lightMapStyle} from '../../consts/light-style-map.const';
import {GoogleMapsApiService} from '../../services/google-maps-api.service';
import {McAddressService} from '../../mc-address.service';
import {MCAddress} from '../../profile/models/mc.address.model';
import {HttpErrorResponse} from '@angular/common/http';
import {UserIntegrityService} from '../../user-integrity.service';
import {Router} from '@angular/router';
import {mobile} from '../../consts/utilities';
import {MatBottomSheet} from '@angular/material/bottom-sheet';
import {MatDialog} from '@angular/material/dialog';
import {FormControl, Validators} from '@angular/forms';
import {AddressAutofillComplementService} from '../../address-autofill-complement.service';

@Component({
    selector: 'app-quick-address-capture',
    templateUrl: './quick-address-capture.component.html',
    styleUrls: ['./quick-address-capture.component.scss']
})
export class QuickAddressCaptureComponent implements OnInit {
    public apiLoaded = false;
    public located = false;
    public userOpenedMap = false;

    public display: any;
    public center: google.maps.LatLngLiteral;
    public zoom = 15;

    public mapOptions: google.maps.MapOptions = {
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        styles: window.matchMedia('(prefers-color-scheme: dark)').matches ? darkStyleMap : lightMapStyle
    };

    public markerOptions: google.maps.MarkerOptions = {
        draggable: false
    };

    public address = '';
    private userEnteredAddress = false;

    private internalAddress: MCAddress = new MCAddress();

    // Error modals
    @ViewChild('unableToLocate', { static: true })
    unableToLocateModal: TemplateRef<any>;

    @ViewChild('unableToSaveAddress', { static: true })
    unableToSaveAddress: TemplateRef<any>;

    @ViewChild('enterCpManually', { static: true })
    enterCpManually: TemplateRef<any>;

    @ViewChild('invalidCp', { static: true })
    invalidCp: TemplateRef<any>;

    public manualCp: FormControl = new FormControl('', [
        Validators.minLength(5),
        Validators.maxLength(5),
        Validators.pattern(/^[0-9]{5}$/)
    ]);

    constructor(
        private userIntegrityService: UserIntegrityService,
        private googleMapsService: GoogleMapsApiService,
        private geolocationService: GeolocationService,
        private mcAddressService: McAddressService,
        private addressAutoFillService: AddressAutofillComplementService,
        private titleService: AppTitleService,
        private scriptService: ScriptService,
        private renderer: Renderer2,
        private router: Router,
        private config: ConfigService,
        private bottomSheet: MatBottomSheet,
        private dialog: MatDialog,
    ) {
        this.titleService.setTitle('Ubicación');

        const mapsApiKey = config.mapsApiKey;
        const mapsLib = this.scriptService.loadJsScript(
            this.renderer,
            `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}`,
        );

        mapsLib.onload = (e) => {
            this.apiLoaded = true;
        };
    }

    ngOnInit(): void {}

    private geocodeCoords(
        latLng: google.maps.LatLngLiteral,
        onResponse: (response: any) => void,
        onError: (error: HttpErrorResponse) => void
    ): void {
        const { lat, lng } = latLng;

        this.internalAddress.lat = lat;
        this.internalAddress.lng = lng;

        this.googleMapsService.geocodingRequest(lat, lng).subscribe(
            (response) => onResponse(response),
            (error) => onError(error)
        );
    }

    private setInternalAddress(addr: any): void {
        // const ext = addr[0].long_name;
        // const street = addr[1].long_name;
        // const sub = addr[2].long_name;
        // const city = addr[3].long_name;
        // const state = addr[4].long_name;
        // const pc = addr[6].long_name;

        const { long_name: ext = 'n/a' } = addr[0].long_name;
        const { long_name: street = 'n/a' } = addr[1].long_name;
        const { long_name: sub = 'n/a' } = addr[2].long_name;
        const { long_name: city = 'n/a' } = addr[3].long_name;
        const { long_name: state = 'n/a' } = addr[4].long_name;
        const { long_name: pc = 'n/a' } = addr[6].long_name;

        this.internalAddress.calle = street;
        this.internalAddress.numero_ext = ext;
        this.internalAddress.numero_int = null;
        this.internalAddress.colonia = sub;
        this.internalAddress.ciudad = city;
        this.internalAddress.estado = state;
        this.internalAddress.codigo_postal = pc;
    }

    moveMap(event: google.maps.MapMouseEvent) {
        if (event.latLng !== null) {
            this.center = (event.latLng.toJSON());

            this.geocodeCoords(
                this.center,
                (response) => {
                    const { data } = response;
                    const { results } = data;
                    const addr = results[0].address_components;
                    const ext = addr[0].long_name;
                    const street = addr[1].long_name;
                    const sub = addr[2].long_name;
                    const city = addr[3].long_name;
                    const state = addr[4].long_name;
                    const pc = addr[6].long_name;

                    this.address = pc;
                    this.setInternalAddress(addr);

                    console.log(`${street} ${ext}, ${sub}, ${pc}, ${city}, ${state}`);
                },
                (error) => {
                    // Error getting address

                    // Notify error to user
                    if (mobile()) {
                        this.bottomSheet.open(this.unableToLocateModal);
                    }

                    if (!mobile()) {
                        this.dialog.open(this.unableToLocateModal);
                    }
                }
            );
        }
    }

    move(event: google.maps.MapMouseEvent) {
        if (event.latLng !== null) { this.display = event.latLng.toJSON(); }
    }

    public requestLocation(): void {
        if (this.userEnteredAddress) {
            this.saveAddress();
            return;
        }

        this.geolocationService.getCurrentLocation().subscribe(
            value => {
                const { lat, lng } = value;

                this.center = {lat, lng};
                this.located = true;

                this.geocodeCoords(
                    this.center,
                    (response) => {
                        const { data } = response;
                        const { results } = data;
                        const addr = results[0].address_components;

                        const { long_name: ext = 'n/a' } = addr[0].long_name;
                        const { long_name: street = 'n/a' } = addr[1].long_name;
                        const { long_name: sub = 'n/a' } = addr[2].long_name;
                        const { long_name: city = 'n/a' } = addr[3].long_name;
                        const { long_name: state = 'n/a' } = addr[4].long_name;
                        const { long_name: pc = 'n/a' } = addr[6].long_name;

                        this.address = pc;
                        this.setInternalAddress(addr);

                        if (pc === 'n/a') {
                            if (mobile()) {
                                this.bottomSheet.open(this.invalidCp);
                            }

                            if (!mobile()) {
                                this.dialog.open(this.invalidCp);
                            }
                            return;
                        }

                        this.saveAddress();
                        // console.log(`${street} ${ext}, ${sub} ${pc}, ${city}, ${state}`);
                    },
                    (error) => {
                        // Error getting address
                    }
                );
            },
            (error) => {
                console.log(error);

                const { code } = error;

                if (code === 1) {
                    // Notify error to user
                    if (mobile()) {
                        this.bottomSheet.open(this.unableToLocateModal);
                    }

                    if (!mobile()) {
                        this.dialog.open(this.unableToLocateModal);
                    }
                }
            }
        );
    }

    public requestCpManually(): void {
        if (mobile()) {
            this.bottomSheet.open(this.enterCpManually);
        }

        if (!mobile()) {
            this.dialog.open(this.enterCpManually);
        }
    }

    public requestDataByCp(): void {
        if (this.manualCp.valid) {
            const value = this.manualCp.value;
            this.manualCp.setErrors(null);
            this.getSuburbs(value);
            return;
        }

        this.manualCp.setErrors({ invalidCp: true });
    }

    private getSuburbs(codigo: string): void {
        this.addressAutoFillService.autoFillSuburbs(codigo).subscribe(
            (response: any) => {
                const {data, mensaje, statuscode} = response;
                const {ciudad, estado, pais} = data[0];

                this.internalAddress.calle = '';
                this.internalAddress.numero_ext = '0';
                this.internalAddress.colonia = '';
                this.internalAddress.estado_id = estado;
                this.internalAddress.ciudad_id = ciudad;
                this.internalAddress.codigo_postal = codigo;

                this.dismissMessage();

                this.located = true;
                this.address = codigo;
                this.userEnteredAddress = true;

                this.saveAddress();
            },
            (error) => {
                this.manualCp.setErrors({ notFound: true });
            }
        );
    }

    public saveAddress(): void {
        this.mcAddressService.postAddress(this.internalAddress, 'auto').subscribe(
            (response) => {
                this.userIntegrityService.checkNow();

                const checkerValue = this.userIntegrityService.currentValue;
                const { card, email } = checkerValue;

                if (card === 1 && email === 1) {
                    this.router.navigate(['/app/dashboard/cards']);
                    return;
                }
            },
            (error: HttpErrorResponse) => {
                console.error(error);

                const { error: ex } = error;
                const { statusCode, message } = ex;

                // Notify error to user
                if (mobile()) {
                    this.bottomSheet.open(this.unableToSaveAddress);
                }

                if (!mobile()) {
                    this.dialog.open(this.unableToSaveAddress);
                }
            }
        );
    }

    public dismissMessage(): void {
        if (mobile()) {
            this.bottomSheet.dismiss();
        }

        if (!mobile()) {
            this.dialog.closeAll();
        }
    }
}
